module.exports = __webpack_public_path__ + "img/picture8.b12e02eb.png";